import { register, CloudObject, defineProperty, defineRelation, Direction } from 'olympe';
import System from "./System";
import InspectionState from "./InspectionState";
import Observation from "./Observation";
import Feedback from "./Feedback";

/**
 * @extends {CloudObject}
 */
export default class Unit extends CloudObject {
    /**
     * @return {string}
     */
    getName() {
        return this.get(Unit.nameProp);
    }
}

// Hardcoded tags
register('0188d02c9b3a6b1279ed', Unit);
Unit.nameProp = defineProperty('0188d02cf78d955feaab');
Unit.feedbacksRel = defineRelation('0188d02d2c8d18935c6c', Unit, Feedback);
Unit.observationsRel = defineRelation('0188d02d79fba3bf02ce', Unit, Observation);
Unit.statesRel = defineRelation('0188d02dd595cf5ad17d', Unit, InspectionState);
Unit.systemsRel = defineRelation('0188d02e2563b9acabf3', Unit, System);
Unit.inverse_assessmentunitsRel = defineRelation('0188d02e5ffb9ed101b0', Direction.ORIGIN);
